<template>
  <div class="home-center">
    <div class="batten">
      <van-sticky>
        <!--  导航栏  -->
        <van-nav-bar title="标题" left-text="返回" left-arrow>
          <template #right>
            <van-icon
              name="wap-nav"
              size="20"
              color="#000000"
              @click="goMenu"
            />
          </template>
          <template #left>
            <van-icon
              v-show="picShow"
              :name="pic"
              size="26"
              color="#000000"
              @click="goUser"
            />
          </template>
          <template #title>
            <van-search
              v-model="editValue"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
              @cancel="onCancel"
              shape="round"
              class="search"
            >
              <template #action>
                <div @click="onClickButton">搜索</div>
              </template>
              <template #left-icon>
                <van-icon name="search" size="18" color="#000000" />
              </template>
            </van-search>
          </template>
        </van-nav-bar>
        <!--  /导航栏  -->

        <!--  tab标签  -->
        <van-tabs
          v-model:active="apiActive"
          title-active-color="#ee0a24"
          v-show="apiShow"
          @click="apitab(apiActive)"
        >
          <van-tab
            v-for="(apiItem, index) in apiItems"
            :key="index"
            :title="apiItem.name"
            :name="index"
          >
          </van-tab>
        </van-tabs>

        <van-tabs
          v-model:active="keyActive"
          class="tab"
          @click="keytab(keyActive)"
          title-active-color="#ee0a24"
        >
          <van-tab
            v-for="(keyWord, index) in keyWords"
            :key="index"
            :title="keyWord"
            :name="keyWord"
            :badge="badgeContent(keyWord)"
          >
          </van-tab>
        </van-tabs>
        <!--  /tab标签  -->
      </van-sticky>
    </div>

    <!--  图片列表框  -->
    <van-pull-refresh
      v-model="load"
      @refresh="onRefresh"
      loosing-text="松开手即可刷新"
      loading-text="正在刷新.."
      :style="videolist"
    >
      <div class="videolist">
        <van-row gutter="5" justify="space-between">
          <van-col
            span="8"
            v-for="(videolist, index) in videolists"
            :key="index"
            @click="listClick(videolist)"
          >
          

            <div class="img">
              <van-image :src="videolist.videoimg" />
              <van-tag
                class="tag"
                color="rgba(10, 10, 10, 0.5)"
                text-color="#FFFFFF"
                >{{ videolist.videotime }}</van-tag
              >
            </div>
          
            <!--  <p>{{ videolist.videoname }}</p>-->
          </van-col>
        </van-row>
      </div>
    </van-pull-refresh>
    <!--  /图片列表框  -->
     <!-- 分页 "-->
     <vant-like-pagination
      :currentPage="page"
      :total-pages="totalPages"
      :on-page-change="handlePageChange"
      :visible-page-count="5"
    ></vant-like-pagination>
    
    <!--  底部标签  -->
    <van-divider v-show="loadShow">已经到底了</van-divider>
    <!--  /底部标签  -->

    <!--  个人中心  -->
    <van-popup
      v-model:show="userpopup"
      closeable
      position="left"
      :style="{ height: '100%', width: '60%' }"
      round
    >
      <div class="userinfo">
        <div class="custom-title">
          <van-uploader :after-read="afterRead">
            <van-image round width="50px" height="50px" :src="pic" />
          </van-uploader>
        </div>
      </div>

      <div class="divcenter">
        <span @click="editName"> {{ name }}</span>
        <van-tag color="#FF88C2" text-color="#FFFFFF" @click="editName"
          >编辑</van-tag
        >
      </div>

      <div class="divcenter">
        <van-tag type="success" @click="Exchange">积分:{{ integral }}</van-tag>
        <van-tag color="#FF8888" mark @click="signIn">签到</van-tag>
      </div>
      <div class="divcenter">
        <van-tag :color="vipTagcolor" @click="Recharge">VIP</van-tag>
        <van-tag color="#ffe1e1" text-color="#ad0000" @click="Recharge">{{
          expirationTime
        }}</van-tag>
      </div>
      <van-cell-group inset class="menu">
        <van-cell
          class="menu-cell"
          icon="cart-o"
          title="会员充值"
          value=""
          @click="Recharge"
        />
        <van-cell
          class="menu-cell"
          icon="balance-o"
          title="积分提现"
          value=""
          @click="Cash"
        />
        <van-cell
          class="menu-cell"
          icon="gift-o"
          title="兑换会员"
          value=""
          @click="Exchange"
        />
        <van-cell
          class="menu-cell"
          icon="award-o"
          title="返佣记录"
          value=""
          to="/rebate"
        />
        <van-cell
          class="menu-cell"
          icon="guide-o"
          title="推广赚钱"
          value=""
          @click="invite"
        />

        <van-cell
          class="menu-cell"
          icon="flag-o"
          title="下载APP"
          value=""
          @click="dow"
        />
        
        <van-cell
          class="menu-cell"
          icon="smile-o"
          title="联系客服"
          value=""
          @click="contact"
        />
        <van-cell
          class="menu-cell"
          icon="todo-list-o"
          title="历史记录"
          value=""
          to="/record?type=0"
        />
        <van-cell
          class="menu-cell"
          icon="star-o"
          title="我的收藏"
          value=""
          to="/record?type=1"
        />
        <van-cell
          class="menu-cell"
          icon="bag-o"
          title="修改密码"
          value=""
          to="/revise"
        />
        <van-cell
          class="menu-cell"
          icon="brush-o"
          title="清除缓存"
          value=""
          @click="eliminate"
        />
        <van-cell
          class="menu-cell"
          icon="setting-o"
          title="退出登录"
          value=""
          @click="logout"
        />
      </van-cell-group>
    </van-popup>
    <!--  /个人中心  -->

    <!-- /编辑昵称 -->
    <van-dialog
      v-model:show="nameShow"
      title="编辑昵称"
      confirmButtonText="保存"
      @confirm="conserve"
    >
      <van-field
        v-model="name"
        label=""
        placeholder="请输入昵称"
        maxlength="15"
        autofocus
      /><!--input-align="center"-->
    </van-dialog>
    <!-- /编辑昵称 -->

    <!--菜单弹出层-->
    <van-popup
      v-model:show="menupopup"
      position="bottom"
      :style="{ height: '100%' }"
      closeable
      class="cute-european-popup"
    >
      <van-cell-group inset class="searchrecords" v-show="searchTextShow">
        <van-cell title="搜索记录" value="清除" @click="emptyKey" />
        <van-row gutter="7" justify="space-between">
          <van-col
            span="4.5"
            v-for="(searchText, index) in searchTexts"
            :key="index"
            ><van-tag
              type="danger"
              round
              color="#00BFFF"
              text-color="#FFFFFF"
              class="menutag"
              @click="searchTextTag(searchText)"
              >{{ searchText.text }}</van-tag
            ></van-col
          >
        </van-row>
      </van-cell-group>

      <van-cell-group inset class="searchrecords">
        <van-cell title="资源分类" value="" />
        <van-row gutter="7" justify="space-between">
          <van-col span="4.5" v-for="(keyWord, index) in keyWords" :key="index"
            ><van-tag
              type="danger"
              round
              color="#00BFFF"
              text-color="#FFFFFF"
              class="menutag"
              @click="keyWordTag(keyWord)"
              
              >{{ keyWord }}</van-tag
            ></van-col
          >
        </van-row>
      </van-cell-group>
      <!-- <button v-for="(item, index) in 8" :key="index">测试</button>-->
    </van-popup>
    <!--/菜单弹出层-->

    <!--分享-->
    <van-share-sheet
      v-model:show="showShare"
      title="分享给好友"
      :cancel-text="canceltext"
      :options="options"
      @select="onSelect"
      @cancel="overlay"
    >
      <template #description>
        <vue-qr :text="shareLink" :size="100"></vue-qr>
        <h3 @click="ShareClick">{{ shareContent }}</h3>
      </template>
    </van-share-sheet>
    <!--/分享-->
    <!--加载-->
    <div class="center-in-center" v-show="loadingShow">
      <van-loading color="#FFFFFF" text-color="#FFFFFF" vertical></van-loading>
    </div>
    <!--/加载-->
  </div>
</template>

<script>
import Axios from "axios";
import config from "../common/config";
import common from "../common/common";
import VueQr from "vue-qr";
import { Notify, Toast, Dialog } from "vant";
import VantLikePagination from "../components/VantLikePagination.vue"; // 根据实际路径导入组件
export default {
  data() {
    return {
      videolist: "margin-top: 45px;", //视频列表样式
      vipTagcolor: "#FF0000", //vip图标颜色

      searchApi: "", //搜索api
      text: "", //关键词
      page: 1, //页码
      totalPages: "", //总页数
      searchTexts: [], //搜索历史

      name: "", //昵称
      username: "", //用户名
      pic: "user-circle-o", //头像初始图标
      expirationTime: "", //到期时间
      etimestamp: "", //到期时间戳
      integral: "", //积分
      editValue: "", //编辑框内容
      api: "",
      keyActive: 0, //关键词默认值
      apiActive: 0, //Api默认值

      videolists: [], //视频数据列表
      keyWords: [], //关键词数据列表
      apiItems: [], //接口数据列表
      apiShow: false, //接口Tab展示
      loadShow: false, //触底标签
      picShow: true, //头像展示
      userpopup: false, //用户中心弹出层展示
      menupopup: false, //菜单弹出层展示
      load: false, //下拉刷新
      nameShow: false, //昵称展示
      searchTextShow: false,
      pay: "", //支付地址
      notice: "", //公告
      token: "",
      scrollTop: 0, //滚动条高度
      showShare: false, //分享弹出层展示
      canceltext: "", //分享弹出层按钮标题
      options: [
        { name: "微信", icon: "wechat" },
        { name: "QQ", icon: "qq" },
        { name: "复制链接", icon: "link" },
      ], //分享按钮配置
      shareLink: "", //分享链接
      shareContent: "", //分享内容
      times: null, //心跳包定时器
      loadingShow: true,
      free:"",
      ferrshow:false,

    }
  },
  components: {
    VueQr,
    VantLikePagination
  },
  methods: {
    //点击分页
    handlePageChange(newPage) {
      this.page = newPage
      this.menupopup = false
      this.videolists = []
      this.getVideo()
    },

    //给Tab添加免费或VIP角标
    badgeContent(keyWord) { // 接收索引和标签标题作为参数
      // 根据特定条件确定角标的内容

      if(this.free == "0" || this.free == ""){
        return ''
      }
      if (this.free.indexOf(keyWord) !== -1) {
        return ''
      }else{
        return 'VIP'
      }
    },

    change(e) {
      this.page = e;
      this.videolist = [];
      document.documentElement.scrollTop = 0;
      if (this.apiItems.length > 1) {
        this.apiShow = true;
      } else {
        this.apiShow = false;
      }
      this.getVideo();
    },
    //分享图标单击事件
    onSelect(e) {
      if (e.name == "微信") {
        this.canceltext = "去微信粘贴给好友";
        this.handelCopyLink(this.shareContent);
      }
      if (e.name == "QQ") {
        this.canceltext = "去QQ粘贴给好友";
        this.handelCopyLink(this.shareContent);
      }
      if (e.name == "复制链接") {
        this.canceltext = "取消";
        this.handelCopyLink(this.shareLink);
      }
    },

    //点击打开微信QQ按钮
    overlay() {
      if (this.canceltext == "去微信粘贴给好友") {
        window.location.href = "weixin://";
      }
      if (this.canceltext == "去QQ粘贴给好友") {
        window.location.href =
          "mqqwpa://im/chat?chat_type=wpa&uin=&version=1&src_type=web&web_src=http:://wpa.b.qq.com";
      }
    },
    //复制内容到粘贴板
    handelCopyLink(val) {
      this.$copyText(val).then(
        function (e) {
          Toast({
            message: "复制成功",
            position: "bottom",
          });
        },
        function (e) {
          Toast({
            message: "复制失败",
            position: "bottom",
          });
        }
      );
    },
    //点击复制分享内容
    ShareClick() {
      this.handelCopyLink(this.shareContent);
    },
    //清空关键词记录列表
    emptyKey() {
      Dialog.confirm({
        title: "温馨提示",
        message: "您确定清空您的搜索记录么?",
      })
        .then(() => {
          localStorage.removeItem("TsBox_searchText");
          Notify({ type: "success", message: "清除成功" });
          this.menupopup = false;
          this.$router.go(0);
        })
        .catch(() => {
          // on cancel
        });
    },
    //搜索历史标签单击
    searchTextTag(e) {
      this.page = 1;
      this.text = e.text;
      this.searchApi = e.searchApi;
      this.menupopup = false;
      this.videolists = [];
      this.getVideo();
    },
    //关键词分类标签单击
    keyWordTag(e) {
      this.page = 1;
      this.text = e;
      this.menupopup = false;
      this.videolists = [];
      this.getVideo();
    },
    dow() {
      window.location.href = "./TsBox.apk";
    },
    //邀请好友
    invite() {
      Toast.loading({
        message: "",
        forbidClick: true,
        loadingType: "spinner",
        duration: 500,
      });
      var url = config.app_host + "/api/share_link?username=" + this.username;
      Axios.post(url).then((response) => {
        if (response.data.code == "0") {
          this.shareLink = decodeURIComponent(response.data.msg);
          this.shareContent = config.shareinfo.content + this.shareLink;
          this.showShare = true;
          return;
        }
      });
      this.shareLink = config.shareinfo.link;
      this.shareContent = config.shareinfo.content + this.shareLink;
      this.showShare = true;
    },
    //联系客服
    contact() {
      if (config.contact.type == "0") {
        window.location.href = config.contact.url;
        return;
      }
      window.open(config.contact.url);
    },
    //充值
    Recharge() {
      if (config.pay.type == "0") {
        this.$router.push({ path: "/recharge" });
        return;
      }
     window.open(config.pay.url + "?username=" + this.username);
    },
    //切换兑换会员
    Exchange() {
      this.$router.push({ path: "/exchange" });
    },
    //切换兑换现金
    Cash() {
      this.$router.push({ path: "/cash" });
    },
    //签到
    signIn() {
      Toast.loading({
        message: "",
        forbidClick: true,
        loadingType: "spinner",
        duration: 500,
      });
      var time = Math.round(new Date().getTime() / 1000).toString();
      var url =
        config.app_host +
        "/api/sign_in?appid=" +
        config.appid +
        "&appkey=" +
        config.appkey +
        "&username=" +
        config.logininfo.username +
        "&time=" +
        time +
        "&sign=" +
        common.md5(
          "appid=" +
            config.appid +
            "&appkey=" +
            config.appkey +
            "&username=" +
            config.logininfo.username +
            "&time=" +
            time +
            config.secret_key
        );
      Axios.get(url)
        .then((response) => {
          var Redata = common.base64_decode(response.data);
          Redata = common.authcode(Redata, "DECODE", config.secret_key);
          Redata = decodeURIComponent(Redata);
          Redata = JSON.parse(Redata);
          this.loadingShow = false;
          if (Redata.code == "0") {
            Notify({ type: "success", message: Redata.msg });
            this.getUserInfo();
            return;
          }
          Notify({ message: Redata.msg, duration: 1500 });
        })
        .catch((error) => {
          Toast({
            message: "签到失败",
            position: "bottom",
          });
        });
    },
    //保存昵称
    conserve() {
      var time = Math.round(new Date().getTime() / 1000).toString();
      var url =
        config.app_host +
        "/api/upload_name?appid=" +
        config.appid +
        "&appkey=" +
        config.appkey +
        "&username=" +
        config.logininfo.username +
        "&name=" +
        this.name.replace(/\s+/g, "") +
        "&time=" +
        time +
        "&sign=" +
        common.md5(
          "appid=" +
            config.appid +
            "&appkey=" +
            config.appkey +
            "&username=" +
            config.logininfo.username +
            "&name=" +
            this.name.replace(/\s+/g, "") +
            "&time=" +
            time +
            config.secret_key
        );
      Axios.get(url)
        .then((response) => {
          var Redata = common.base64_decode(response.data);
          Redata = common.authcode(Redata, "DECODE", config.secret_key);
          Redata = decodeURIComponent(Redata);
          Redata = JSON.parse(Redata);
          if (Redata.code == "0") {
            Notify({ type: "success", message: Redata.msg });
            return;
          }
          Notify({ message: Redata.msg, duration: 1500 });
        })
        .catch((error) => {
          Toast({
            message: "昵称修改失败",
            position: "bottom",
          });
        });
    },
    //点击编辑昵称
    editName() {
      this.$router.push({ path: "/usercenter" });
    },
    //上传头像
    afterRead(e) {
      Toast.loading({
        message: "",
        forbidClick: true,
        loadingType: "spinner",
        duration: 500,
      });
      if (
        (e.file.type !== "image/jpeg") ^
        (e.file.type !== "image/png") ^
        (e.file.type !== "image/jpg")
      ) {
        Toast("请上传 jpg 或 png 格式图片");
        return false;
      }
      var time = Math.round(new Date().getTime() / 1000).toString();
      let con = { headers: { "Content-Type": "multipart/form-data" } }; //添加请求头
      var url =
        config.app_host +
        "/api/upload_pic?appid=" +
        config.appid +
        "&appkey=" +
        config.appkey +
        "&username=" +
        config.logininfo.username +
        "&time=" +
        time +
        "&sign=" +
        common.md5(
          "appid=" +
            config.appid +
            "&appkey=" +
            config.appkey +
            "&username=" +
            config.logininfo.username +
            "&time=" +
            time +
            config.secret_key
        );
      Axios.post(url, e, con)
        .then((response) => {
          var Redata = common.base64_decode(response.data);
          Redata = common.authcode(Redata, "DECODE", config.secret_key);
          Redata = decodeURIComponent(Redata);
          Redata = JSON.parse(Redata);
          if (Redata.code == "0") {
            Notify({ type: "success", message: "头像更换成功" });
            this.pic = e.content;
            return;
          }
          Notify({ message: Redata.msg, duration: 1500 });
        })
        .catch((error) => {
          Toast({
            message: "头像上传失败",
            position: "bottom",
          });
          this.empty();
        });
    },

    //搜索按钮单击事件
    onClickButton() {
      this.page = 1;
      this.text = this.editValue;
      this.videolists = [];
      //this.loadingShow = true
      var ojb = { text: this.text, searchApi: this.searchApi };
      if (this.editValue != "") {
        this.searchTextShow = true;
        if (localStorage.getItem("TsBox_searchText") != null) {
          this.searchTexts = JSON.parse(
            localStorage.getItem("TsBox_searchText")
          );
          for (var i = 0; i < this.searchTexts.length; i++) {
            if (this.searchTexts[i].text == ojb.text) {
              this.getVideo();
              return;
            }
          }
          this.searchTexts.unshift(ojb);
          localStorage.setItem(
            "TsBox_searchText",
            JSON.stringify(this.searchTexts)
          );
        } else {
          this.searchTexts = [];
          this.searchTexts.unshift(ojb);
          localStorage.setItem(
            "TsBox_searchText",
            JSON.stringify(this.searchTexts)
          );
        }
      } else {
        Toast("请输入搜索关键词");
        return;
      }
      this.getVideo();
    },
    //清空搜索编辑框
    onSearch() {
      this.onClickButton();
    },
    onCancel() {
      this.editValue = "";
    },
    //下拉刷新
    onRefresh() {
      this.videolists = [];
      this.loadingShow = true;
      this.getVideo();
    },

    //api tab列表
    apitab(e) {
      this.keyWords = [];
      this.keyWords = config.apiinfo[e].key.split(",");
      this.searchApi = config.apiinfo[e].url;
      this.text = this.keyWords[0];
      this.page = 1;
      this.videolists = [];
      this.getVideo();
    },
    //关键词tab列表
    keytab(e) {
      this.text = e;
      this.page = 1;
      this.videolists = [];
      this.getVideo();
    },

    //点击图片框
    listClick(e) {      
      var time = Math.round(new Date().getTime() / 1000).toString();
      //判断运营模式
      if (config.appinfo.mode == "0") {
        this.$router.push({ path: "/video", query: { video: e } });
        return;
      }
      //判断是否登录
      if (config.state == false) {
        Dialog.alert({
          title: "温馨提示",
          message: "您还未登录,请先登录",
          theme: "round-button",
          confirmButtonText: "登录",
        }).then(() => {
          this.$router.push({ path: "/Login" });
        });
        return;
      }
      //判断分类是否为免费
      if (this.free.indexOf(this.text) !== -1) {
        this.$router.push({ path: "/video", query: { video: e } });
        return;
      } 
      //判断是否会员是否到期
      if (config.logininfo.etimestamp < time) {
        Dialog.alert({
          title: "系统提示",
          message: "您的会员已到期,充值后即可播放所有资源",
          theme: "round-button",
          confirmButtonText: "立即充值",
        }).then(() => {
          if (config.pay.type == "0") {
            this.$router.push({ path: "/recharge" });
            return;
          }
          window.open(config.pay.url);
        });
        return;
      }
      //切换播放窗口
      this.$router.push({ path: "/video", query: { video: e } });
    },
    //点击进入个人中心
    goUser() {
      if (config.state == false) {
        Dialog.alert({
          title: "温馨提示",
          message: "您还未登录,请先登录",
          theme: "round-button",
          confirmButtonText: "登录",
        }).then(() => {
          this.$router.push({
            path: "/Login",
          });
        });
        return;
      }
      this.userpopup = true;
    },
    //点击右上角菜单
    goMenu() {
      this.menupopup = true;
    },

    //弹出公告
    bombAnnouncement() {
      Dialog.alert({
        title: "公告",
        message: this.notice,
      }).then(() => {
        config.notice = true;
        localStorage.setItem(
          "TsBox_notice",
          Math.round(new Date().getTime() / 1000).toString()
        );
      });
    },
    //获取应用配置
    getConfig() {
      var url = config.app_host + "/api/ini?appid=" + config.appid;
      Axios.get(url)
        .then((response) => {
          var Redata = common.base64_decode(response.data);
          Redata = common.authcode(Redata, "DECODE", config.secret_key);
          Redata = JSON.parse(Redata);
          config.appinfo = Redata.app; //应用配置数组对象
          config.apiinfo = Redata.api; //api数组对象
          config.extend = Redata.extend; //扩展配置数组对象
          for (var i = 0; i < config.extend.length; i++) {
            //充值地址 及 充值类型
            if (Redata.extend[i].key == "pay") {
              config.pay = eval("(" + Redata.extend[i].value + ")");
            }
            //客服链接 及 跳转类型
            if (Redata.extend[i].key == "contact") {
              config.contact = eval("(" + Redata.extend[i].value + ")");
            }
            //充值配置信息
            if (Redata.extend[i].key == "payinfo") {
              config.payinfo = eval("(" + Redata.extend[i].value + ")");
            }

            //公告
            if (Redata.extend[i].key == "notice") {
              this.notice = Redata.extend[i].value;
            }

            //分享配置信息
            if (Redata.extend[i].key == "shareinfo") {
              config.shareinfo = eval("(" + Redata.extend[i].value + ")");
            }

            //兑换会员配置信息
            if (Redata.extend[i].key == "exchangeinfo") {
              config.exchangeinfo = eval("(" + Redata.extend[i].value + ")");
            }

            //兑换现金配置信息
            if (Redata.extend[i].key == "cashinfo") {
              config.cashinfo = eval("(" + Redata.extend[i].value + ")");
            }
            //免费分类配置
            if (Redata.extend[i].key == "free") {
              this.free = Redata.extend[i].value;
            }
          }
          //判断应用是否关闭
          if (config.appinfo.state != "0") {
            Dialog.alert({
              title: "系统提示",
              message: config.appinfo.notice,
              theme: "round-button",
            }).then(() => {});
            this.picShow = false;
            return;
          }

          //免费模式则隐藏头像
          if (config.appinfo.mode == "0") {
            this.picShow = false;
          }
          //公告

          if (localStorage.getItem("TsBox_notice") != null) {
            if (
              Math.round(new Date().getTime() / 1000).toString() -
                localStorage.getItem("TsBox_notice") <
              3600
            ) {
              config.notice = true;
            }
          }
          if (config.notice == false) {
            this.bombAnnouncement(); //首次加载完毕弹出公告
          }
          localStorage.setItem("TsBox_app_host", config.app_host);
          localStorage.setItem(
            "TsBox_payinfos",
            JSON.stringify(config.payinfo)
          );
          localStorage.setItem(
            "TsBox_cashinfos",
            JSON.stringify(config.cashinfo)
          );
          localStorage.setItem(
            "TsBox_exchangeinfos",
            JSON.stringify(config.exchangeinfo)
          );
          localStorage.setItem("TsBox_pay", config.pay.url);
          localStorage.setItem("TsBox_wxpay", Redata.app.wxpay);
          localStorage.setItem("TsBox_alipay", Redata.app.alipay);
          //强制更新
          if (config.edition < config.appinfo.app_bb) {
            Dialog.alert({
              title: "发现新版本",
              message: config.appinfo.app_nshow,
              showCancelButton: true,
              confirmButtonText: "立即更新",
              cancelButtonText: "残忍拒绝",
              theme: "round-button",
            })
              .then(() => {
                window.open(config.appinfo.app_nurl);
              })
              .catch(() => {
                this.bombAnnouncement();
              });
          }

          this.apiItems = config.apiinfo;
          this.keyWords = config.apiinfo[0].key.split(",");
          this.searchApi = config.apiinfo[0].url;
          this.text = this.keyWords[0];

          if (this.apiItems.length > 1) {
            this.apiShow = true;
            this.videolist = "margin-top: 88px;";
          } else {
            this.apiShow = false;
            this.videolist = "margin-top: 10px;";
          }
          this.getVideo();
        })
        .catch((error) => {
          Toast({
            message: "App配置获取失败",
            position: "bottom",
          });
          this.empty();
        });
    },
    //获取用户信息
    getUserInfo() {
      var time = Math.round(new Date().getTime() / 1000).toString();
      var url =
        config.app_host +
        "/api/token_login?appid=" +
        config.appid +
        "&appkey=" +
        config.appkey +
        "&token=" +
        this.token +
        "&time=" +
        time +
        "&sign=" +
        common.md5(
          "appid=" +
            config.appid +
            "&appkey=" +
            config.appkey +
            "&token=" +
            this.token +
            "&time=" +
            time +
            config.secret_key
        );
      Axios.get(url)
        .then((response) => {
          var Redata = common.base64_decode(response.data);
          Redata = common.authcode(Redata, "DECODE", config.secret_key);
          Redata = decodeURIComponent(Redata);
          Redata = JSON.parse(Redata);

          if (Redata.code == "0") {
            this.name = Redata.info.name;
            this.pic = config.app_host + Redata.info.pic;
            this.expirationTime = Redata.info.expires;
            this.username = Redata.info.username;
            this.integral = Redata.info.integral;
            config.logininfo = Redata.info;
            config.state = true;
            if (config.logininfo.etimestamp < time) {
              this.vipTagcolor = "#666666";
              this.expirationTime = "您的会员已到期";
            }

            localStorage.setItem(
              "TsBox_logininfo",
              JSON.stringify({
                pic: config.logininfo.pic,
                name: config.logininfo.name,
                username: config.logininfo.username,
                expires: config.logininfo.expires,
                integral: config.logininfo.integral,
                alipay: config.logininfo.alipay,
                phone: config.logininfo.phone,
                fullname: config.logininfo.fullname,
              })
            );

            //发送心跳包
            this.times = setInterval(() => {
              this.heartbeat();
            }, 1000 * 120);
          } else {
            Toast({
              message: Redata.msg,
              position: "bottom",
            });
            this.$router.push({ path: "/login" });
          }
        })
        .catch((error) => {
          Toast({
            message: "账号信息获取失败",
            position: "bottom",
          });
          this.empty();
        });
    },
    //心跳包
    heartbeat() {
      var time = Math.round(new Date().getTime() / 1000).toString();
      var url =
        config.app_host +
        "/api/heartbeat?appid=" +
        config.appid +
        "&appkey=" +
        config.appkey +
        "&token=" +
        this.token +
        "&time=" +
        time +
        "&sign=" +
        common.md5(
          "appid=" +
            config.appid +
            "&appkey=" +
            config.appkey +
            "&token=" +
            this.token +
            "&time=" +
            time +
            config.secret_key
        );
      Axios.get(url).then((response) => {
        console.log("heartbeat");
      });
    },
    //获取视频数据
    getVideo() {
      this.loadingShow = true;
      var url = this.searchApi + this.text + "&page=" + this.page;
      Axios.get(url)
        .then((response) => {
          var Redata = common.base64_decode(response.data);
          Redata = common.authcode(Redata, "DECODE", config.secret_key);
          Redata = common.base64_decode(Redata);
          Redata = JSON.parse(Redata);
          this.totalPages = Redata[0].totalPages;
          this.loadingShow = false;
          this.load = false;
          if (Redata.length < 2) {
            this.loadShow = true;
            return;
          }
          this.videolists = Redata;
        })
        .catch((error) => {
          this.loadingShow = false;
          Toast({
            message: "视频列表获取失败",
            position: "bottom",
          });
        });
    },
    empty() {
      this.$router.push({
        path: "/empty",
      });
    },
    //清除缓存
    eliminate() {
      Dialog.confirm({
        title: "TsBox",
        message: "您确定要清除缓存吗?",
      })
        .then(() => {
          localStorage.clear();
          this.show = false;
          window.location.href = "/";
        })
        .catch(() => {
          // on cancel
        });
    },
    //退出登录
    logout() {
      Dialog.confirm({
        title: "TsBox",
        message: "您确定退出当前账户吗?",
      })
        .then(() => {
          localStorage.removeItem("TsBox_token");
          this.show = false;
          window.location.href = "/";
        })
        .catch(() => {
          // on cancel
        });
    },
    random(count) {
      var str =
        "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,0,1,2,3,4,5,6,7,8,9";
      var arr = str.split(",");
      var rand = "";
      for (var i = 0; i < count; i++) {
        rand += arr[Math.floor(Math.random() * 36)];
      }
      return rand;
    },
  },
  mounted() {
    config.app_host = "https://" + this.random(4) + ".tsboxhost.top";
    this.getConfig();

    this.scrollTop = 0;
    localStorage.setItem("TsBox_scrollTop", this.scrollTop);
    localStorage.setItem("TsBox_inv", this.$route.query.inv);

  },
  //窗口切换完毕
  activated() {
      if(config.previousRoutePath === "/Login"){
        this.loadingShow = true;
         setTimeout(() => {
          this.loadingShow = false;
        }, 1500);
      }
     //重新获取滚动条位置
    document.documentElement.scrollTop =
      localStorage.getItem("TsBox_scrollTop");
    this.playRecord = localStorage.getItem("TsBox_playRecord");
    this.searchTexts = JSON.parse(localStorage.getItem("TsBox_searchText"));
    if (this.searchTexts != null) {
      this.searchTextShow = true;
    }

    this.token = localStorage.getItem("TsBox_token");
    if (this.token != null && config.state == false) {
      this.getUserInfo();
      return;
    }
  },
  deactivated() {
    //销毁监听触底
    window.removeEventListener("scroll", this.scrollEvent);
    //销毁心跳包定时器
    clearInterval(this.times);
  },
};
</script>

<style scoped>

 .child {
    width: 40px;
    height: 40px;
    background: #f2f3f5;
    border-radius: 4px;
  }


/* 顶部导航栏样式 */

.home-center {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  margin-bottom: 40px;
}

.batten {
  flex: 1;
}

/* 搜索框样式 */
.search {
  flex: 1;
}

/* 图片列表框样式 */
.videolist {
  height: 100%;
  overflow-y: auto;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 2px;
}

.img {
  overflow: hidden;
  position: relative;
  border-radius: 3%;
}
.img .van-image{
  width: 100%;
  height: 120px;
}


.tag {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

/* 个人中心样式 */
.userinfo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.custom-title {
  position: relative;
}

.custom-title .van-image {
  width: 80px;
  height: 80px;
}

.custom-title .van-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s;
}

.custom-title:hover .van-image::after {
  opacity: 1;
}

.divcenter {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.divcenter span {
  font-size: 18px;
  font-weight: bold;
  margin-right: 5px;
}

.divcenter .van-tag {
  font-size: 12px;
  margin-right: 5px;
  padding: 4px 8px;
  border-radius: 12px;
}

.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 10px;
}

.menu-cell {
  width: 100%;
  padding: 10px;
  margin: 10px;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.menu-cell:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.menu-cell .van-cell__icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.menu-cell .van-cell__title {
  font-size: 13px;
  color: #333;
}


.menu-cell .van-cell__value {
  font-size: 12px;
  color: #999;
}

/* 编辑昵称样式 */
.van-dialog .van-field {
  margin-bottom: 20px;
}

/* 菜单弹出层样式 */
.cute-european-popup {
  /* 自定义弹出层样式 */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  padding: 16px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  margin-top: 20px;
}

.cute-european-popup .searchrecords {
  /* 自定义搜索记录样式 */
  margin-bottom: 16px;
}

.cute-european-popup .searchrecords .van-cell-title,
.cute-european-popup .searchrecords .van-cell-value {
  color: #ff4c4c;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
}

.cute-european-popup .searchrecords .tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cute-european-popup .searchrecords .menutag {
  /* 自定义菜单标签样式 */
  background-color: #ffd6d6;
  color: #ee7a7a;
  font-size: 14px;
  padding: 4px 16px;
  border-radius: 14;
  cursor: pointer;
  margin-top: 2px;
  transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.cute-european-popup .searchrecords .menutag:hover {
  background-color: #ffbfbf;
  box-shadow: 0 0 10px #ff7b7b, 0 0 20px #ff7b7b, 0 0 30px #ff7b7b, 0 0 40px #ff7b7b;
}


/*加载样式 */
.center-in-center {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}

.center-in-center .van-loading {
  font-size: 32px;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>